import { useEffect, useState } from 'react';
import axios from 'axios';
import { HEADER_LIST } from './MarketTableData';
import Pagination from 'react-js-pagination';
import moment from 'moment/moment';
import { changeMarketState } from '../../common/utils';
import MarketInfoModal from './MarketInfoModal';
const xlsx = require('xlsx');
const qs = require('qs');

export default function MarketTable() {
	const [HeaderList, setHeaderList] = useState([]);
	const [TableData, setTableData] = useState([]); // axios에서 받아온 전체 게시글 데이터
	const [Page, setPage] = useState(1); // 현재 페이지 번호
	const [PostPerPage, setPostPerPage] = useState(10); // 페이지 당 게시글 개수
	const [IsPostPerPageOpen, setIsPostPerPageOpen] = useState(false);
	const indexOfLastPost = Page * PostPerPage;
	const indexOfFirstPost = indexOfLastPost - PostPerPage;
	const PageLengthList = [10, 50, 100, 500];
	const [MarketInfoData, setMarketInfoData] = useState();

	const handleBlurPageSizeContainer = () => {
		setTimeout(() => {
			setIsPostPerPageOpen(!IsPostPerPageOpen);
		}, 200);
	};
	const handlePostPerPageOpen = () => {
		setIsPostPerPageOpen(!IsPostPerPageOpen);
	};
	const handlePostPerPage = (e, value) => {
		const newPerPageSize = value;
		if (PostPerPage !== newPerPageSize) {
			setPage(1);
			setPostPerPage(newPerPageSize);
			return;
		}
	};
	const handlePageChange = (page) => {
		if (Page !== page) {
			return setPage(page);
		}
	};

	const handleModalOpen = (item, index) => {
		handleModalContainer(index);
		//진행내용 API
		// axios({
		// })
		// 	.then((res) => {
		// 		setMarketInfoData(res.data.marketInfo[0]);
		// 		handleModalContainer(index);
		// 	})
		// 	.catch();
	};
	const handleModalContainer = (index) => {
		const updatedData = [...TableData];
		for (let i = 0; i < TableData.length; i++) {
			if (TableData[i].idx === index) {
				updatedData[i].isMarketInfoModalOpen =
					!updatedData[i].isMarketInfoModalOpen;
			} else {
				updatedData[i].isMarketInfoModalOpen = false;
			}
		}
		setTimeout(() => {
			setTableData(updatedData);
		}, 200);
	};

	const exportToExcel = () => {
		if (TableData) {
			console.log('엑셀', TableData);
			const originalTableData = TableData;
			// 새로운 데이터 키값과 헤더
			const newDataKeys = {
				marketCode: '마켓코드',
				idx: 'No',
				marketID: '마켓아이디',
				title: '작업줄명',
				regDate: '등록날짜',
				status: '상태',
			};

			// 데이터 키값 변경
			const modifiedTableData = originalTableData.map((item) => {
				const newItem = {};
				for (const key in item) {
					if (key in newDataKeys) {
						// 특정 키값을 변환해서 보내야할 때 아래 조건문 추가
						if (key === 'status') {
							newItem[newDataKeys[key]] = changeMarketState(item[key]);
						}
					}
				}
				console.log('엑셀 - 변환한 행 데이터', newItem);
				return newItem;
			});

			const ws = xlsx.utils.json_to_sheet(modifiedTableData, {
				skipHeader: false, // 첫 번째 행을 열의 제목으로 사용함
			});

			ws['!cols'] = [
				{ wch: 20 }, // A열
				{ wch: 20 }, // B열
				{ wch: 20 }, // C열
				{ wch: 20 }, // D열
				{ wch: 20 }, // E열
				{ wch: 20 }, // F열
				{ wch: 20 }, // G열
				{ wch: 20 }, // H열
				{ wch: 20 }, // I열
				{ wch: 20 }, // J열
				{ wch: 20 }, // K열
				{ wch: 20 }, // L열
			];
			// 워크북 생성 및 시트 추가
			const wb = xlsx.utils.book_new();
			xlsx.utils.book_append_sheet(wb, ws, 'Sheet1');
			xlsx.writeFile(wb, '등록상품 목록 엑셀.xlsx'); //두번쨰 인수는 파일 이름.
		}
	};
	const handleDelete = (item) => {
		/* eslint-disable no-restricted-globals */
		const isOk = confirm(`'${item.title}' 작업을 삭제하시겠습니까?`);
		/* eslint-enable no-restricted-globals */
		if (isOk) {
			//삭제 요청 API
		}
	};
	useEffect(() => {
		setHeaderList(HEADER_LIST);
		axios
			.post(
				`${window.location.protocol}//${window.location.hostname}:3001/getReg`,
				qs.stringify({
					token: localStorage.getItem('token'),
				})
			)
			.then((res) => {
				const DataArray = res.data;
				console.log('regData', DataArray);
				setPage(1);
				setTableData(DataArray || []);
			})
			.catch(function (error) {
				console.log(error);
			});
	}, []);
	return (
		<>
			<div className='market-table'>
				<div className='table-top'>
					<div className='table-top-left'>
						<p>
							총 <span className='pointText'>{TableData.length}</span>건
						</p>
					</div>
					<div className='table-top-right'>
						<div
							className='container'
							onBlur={(e) => handleBlurPageSizeContainer(e)}
						>
							<label onClick={() => handlePostPerPageOpen()}>
								<button className='dropdown-button'>
									<span>{PostPerPage}개씩</span>
									<span className='dropdown-button-arrow'>
										{IsPostPerPageOpen ? '▲' : '▼'}
									</span>
								</button>
							</label>
							{IsPostPerPageOpen && (
								<div
									className={
										IsPostPerPageOpen
											? 'dropdown-container open'
											: 'dropdown-container'
									}
								>
									<ul className='dropdown-content'>
										{PageLengthList.map((el, idx) => (
											<li key={idx} onClick={(e) => handlePostPerPage(e, el)}>
												{el}개씩
											</li>
										))}
									</ul>
								</div>
							)}
						</div>
						<button onClick={exportToExcel} style={{ marginLeft: '10px' }}>
							엑셀다운로드
						</button>
					</div>
				</div>
				<table>
					<thead>
						<tr>
							{HeaderList.map((el, index) => {
								return <th key={el + index}>{el}</th>;
							})}
						</tr>
					</thead>
					<tbody>
						{TableData.length === 0 && (
							<tr className='defaultTable'>
								<td colSpan={HEADER_LIST.length}>
									<div>데이터가 없습니다.</div>
								</td>
							</tr>
						)}
						{TableData?.slice(indexOfFirstPost, indexOfLastPost).map((item) => (
							<tr key={item.marketCode + item.idx}>
								{/**No*/}
								<td>{`${item.marketCode}-${item.idx}`}</td>
								{/**마켓아이디*/}
								<td>{item.marketID}</td>
								{/**작업줄명*/}
								<td>
									<span
										onClick={() => handleModalOpen(item, item.idx)}
										className='clickTd'
									>
										{item.title}
									</span>
									{item.isMarketInfoModalOpen && (
										<MarketInfoModal
											// data={MarketInfoData}
											getMarketInfoModalOpen={() =>
												handleModalContainer(item.idx)
											}
										/>
									)}
								</td>
								{/**등록날짜*/}
								<td>{moment(item.registDate).format('YYYY-MM-DD HH:mm:ss')}</td>
								{/**상태 */}
								<td>{changeMarketState(item.status)}</td>
								{/**진행내용 
								<td>
									<div>
										<button onClick={() => handleCheck(item, 'check')}>
											확인
										</button>
										<button onClick={() => handleCheck(item, 'status')}>
											{item.status !== 'done' ? '중지' : '재시작'}
										</button>
									</div>
								</td>*/}
								{/**삭제*/}
								<td>
									<button onClick={() => handleDelete(item)}>삭제</button>
								</td>
							</tr>
						))}
					</tbody>
				</table>
				<Pagination
					activePage={Page}
					itemsCountPerPage={Number(PostPerPage)}
					totalItemsCount={TableData.length}
					pageRangeDisplayed={10}
					prevPageText={'‹'}
					nextPageText={'›'}
					onChange={handlePageChange}
				/>
			</div>
		</>
	);
}
